/**
 * @flow
 */
import styled from 'react-emotion'
import {
  Typo14White2RR,
  Typo15Tangerine3RR,
  Typo16White2RR
} from '../../../../themes/Fonts'

export const SuccessFormInnerContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 16px;
  align-items: center;
  padding-left: 2.875em;
  padding-right: 2.875em;
  padding-bottom: 0;
  padding-top: 3em;
  @media (min-width: 768px) and (max-width: 1024px) {
    padding-left: 0px;
    padding-right: 0px;
  }
`
const Typo14White2RMWithArticleTag = Typo14White2RR.withComponent('article')
export const SuccessfulFormText = styled(Typo14White2RMWithArticleTag)`
  padding-top: 1.25em;
  text-align: center;
  font-family: din-2014;
`
const Typo15Tangerine3RRWithDiv = Typo15Tangerine3RR.withComponent('div')
export const SuccessfulFormInnerText = styled(Typo15Tangerine3RRWithDiv)`
  font-weight: normal;
  font-family: din-2014;
`

const Typo16White2RRWithArticleTag = Typo16White2RR.withComponent('article')
export const SuccessfulFormSubText = styled(Typo16White2RRWithArticleTag)`
  text-align: center;
  opacity: 0.9;
  padding-bottom: 1em;
  padding-top: 0.833em;
  @media (min-width: 320px) and (max-width: 767px) {
    padding-bottom: 1em;
  }
  font-family: din-2014;
`



// WEBPACK FOOTER //
// ./src/components/IbcArcade/BookingResponseMessage/SuccessFormMessage/styledComponents.js